import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { observer } from 'mobx-react'
import store from './store'
import Table from './Table'
import style from './style.module.less'
import Add from './Add'
import AddStore from './Add/store'
import { Button, Modal, DatePicker, MagicInput } from 'hljd'
import { SINGLE_PRODUCT_PATH } from '@constant'
import { Link } from 'react-router'
import { isImageMogr2 } from '@util'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = this.props
    store.set_meal_id = id

    this.addStore = new AddStore(id)
  }

  componentDidMount() {
    store.getDetails()
  }

  render() {
    let header = [<Link to={SINGLE_PRODUCT_PATH}>单品管理</Link>, '相关案例']

    const {
      info: { actual_price, title, cover_path },
      markVisible,
      mark_content,
      timeVisible,
      shooting_time
    } = store

    return (
      <HeaderView title="相关案例" header={header}>
        <div className={style.info}>
          <img src={isImageMogr2(cover_path, 100, 64)} />
          <div>
            <p>{title}</p>
            <p>价格：￥{actual_price}</p>
          </div>
        </div>

        <div className={style.middle}>
          <p className={style.tip}>
            <span>相关案例</span>（每个单品在APP上最多可显示20个案例）
          </p>
          <Button
            className={style.btn}
            type="primary"
            onClick={this.addStore.showVisible}
          >
            添加案例
          </Button>
        </div>

        <div className={style.caseTable}>
          <Table />
        </div>

        <Add store={this.addStore} />

        <Modal
          title="短标题"
          visible={markVisible}
          onOk={store.doChange('mark')}
          onCancel={store.hideMark}
          width={300}
        >
          <MagicInput
            style={{ width: 200 }}
            maxLength={5}
            showCount
            countPosition="inner"
            onChange={e => store.editMark(e.target.value)}
            value={mark_content}
          />
        </Modal>

        <Modal
          title="拍摄时间"
          visible={timeVisible}
          onOk={store.doChange('time')}
          onCancel={store.hideTime}
          width={300}
        >
          <DatePicker onChange={store.editTime} value={shooting_time} />
        </Modal>
      </HeaderView>
    )
  }
}
